var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileXİcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.7314 28 28 21.7314 28 14C28 6.26855 21.7314 0 14 0C6.26855 0 0 6.26855 0 14C0 21.7314 6.26855 28 14 28ZM12.3104 14.8545L6.45312 7H10.9694L14.8066 12.1475L19.5576 7H20.8826L15.3991 12.9427L21.5833 21.237H17.0705L12.9017 15.6475L7.74398 21.237H6.41667L12.3104 14.8545Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileXİcon);
export default __webpack_public_path__ + "static/media/mobile-x-icon.5d27a5522dfe1191b1b328012758b2f7.svg";
export { ForwardRef as ReactComponent };